<template>
    <div>
        <Input
            search
            :placeholder="placeholder"
            style="width: auto"
            v-model="innerDomainName"
            @on-enter="handleDomainSearch"
            @on-search="handleDomainSearch"
        />
    </div>
</template>

<script>
import { getEsData } from "@/api/esdata";

export default {
    name: "SearchDomainAtProfileInput",
    props: {
        value: { type: String, default: "" },
        searchSize: { type: Number, default: 10 },
        isFuzzySearch: { type: Boolean, default: true },
        placeholder: { type: String, default: "Search Domain Name" },
    },
    data() {
        return {
            isTableLoading: false,
            searchOptions: {
                searchView: "AppProfile",
                esIndex: "rcm-app-profiles",
                isFuzzySearch: this.isFuzzySearch,
                from: 0,
                size: this.searchSize,
                filters: [],
                crossIndexSearch: {
                    targetIndex: "rcm-nginxconfigs",
                    filters: [],
                    aggsSize: this.searchSize,
                    returnKeyField: "appProfileName",
                },
                sort: [{ modifiedDate: { order: "desc" } }],
            },
            getEsResult: {},
            tableData: [],
            tableDataTotal: 0,
        };
    },
    watch: {
        isFuzzySearch(val) {
            this.searchOptions.isFuzzySearch = val;
        },
        searchSize(val) {
            this.searchOptions.size = val;
            this.searchOptions.crossIndexSearch.aggsSize = val;
        },
    },
    computed: {
        innerDomainName: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit("input", typeof v === "string" ? v.trim() : v);
            },
        },
        // 從 store 取得目前的 groupName，並做 'all' → '*'
        currentGroupName() {
            const q = this.$store.state.queryGroupName;
            if (q === "all") return "*";
            return q;
        },
    },
    methods: {
        async handleDomainSearch() {
            try {
                this.isTableLoading = true;
                this.$emit("loading", true);

                // 依據輸入動態建置 filters（空字串 = 查全部，不做 crossIndexSearch）
                this.buildDomainAtProfileFilters();

                const res = await getEsData(this.searchOptions);

                // 設定表格資料
                this.$emit("result", {
                    tableData: res.data.mapData,
                    total: res.data.total,
                    esResult: res.data,
                });
            } catch (error) {
                // 設定空的表格資料
                this.$emit("result", {
                    tableData: [],
                    total: 0,
                    esResult: {},
                });
                this.$emit("error", error);
            } finally {
                this.isTableLoading = false;
                this.$emit("loading", false);
            }
        },
        // 依據 innerDomainName 建置 filters
        buildDomainAtProfileFilters() {
            // 重置
            this.searchOptions.filters = [];
            this.searchOptions.crossIndexSearch.filters = [];

            // 共用的 groupName 條件
            const groupFilter = {
                key: "groupName",
                type: "string",
                value: this.currentGroupName,
            };

            if (this.innerDomainName === "") {
                // 空字串：查所有 appProfile
                this.searchOptions.filters = [groupFilter];
                return;
            }

            // 有輸入 domain, crossIndex 都加條件
            const serverFilter = {
                key: "servername",
                type: "string",
                value: this.innerDomainName,
            };

            this.searchOptions.filters = [groupFilter];
            this.searchOptions.crossIndexSearch.filters = [groupFilter, serverFilter];
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/SearchDomainAtProfileInput.vue